import React, { useState, useEffect } from "react";
import { store } from "../../../store/store";
import { EmailCampaignDetailsTab } from './tabs/EmailCampaignDetailsTab';
import { hideNotification } from '../../../store/actions/notification';
import { NOTIFICATION_ERROR } from '../../../store/actions/types';

function EmailCampaignDetailsComponent(props) {
  const { emailCampaign } = props;
  const [ activeTab, setActiveTab ] = useState('emailCampaign');

  useEffect(() => {
    const tab = new URLSearchParams(props.location.search).get("tab");

    if (tab) {
      if (activeTab !== tab) {
        setActiveTab(tab);
      }
    }

    return () => {
      if (store.getState().notification.type === NOTIFICATION_ERROR) {
        store.dispatch(hideNotification());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="email-campaign-details">
      {activeTab === 'emailCampaign' && (
        <EmailCampaignDetailsTab emailCampaign={emailCampaign}/>
      )}
    </div>
  );
}

export { EmailCampaignDetailsComponent };
